class HtmlEditorView extends Backbone.View
  template: JST['backbone/templates/htmleditor']

  events:
    'change .url_image': 'loadImage'
    'change .img_width': 'changeImgSettings'
    'change .img_height': 'changeImgSettings'
    'change .img_border': 'changeImgSettings'
    'change .img_esp_h': 'changeImgSettings'
    'change .img_esp_v': 'changeImgSettings'
    'click .img_lock': 'toggleImgLock'
    'click .btn_insert_img' : 'insertImage'
    'click #add-image-close' : 'closeModal'
    'click #add-image-cancel' : 'closeModal'
    'click #add-image-accept' : 'closeModal'

  @create: ($el, options) ->
    new HtmlEditorView($.extend({ el: $el }, options))

  onChange: undefined

  initialize: (@options) ->
    @text = @options.text
    @boxSize = @options.boxSize || 4
    @textLimit = @options.textLimit
    @textareaId = UniqueId.generate()
    @codeEditorEnabled = @options.codeEditorEnabled || false

  render: ->
    @$el.html @template({ @textareaId, @boxSize, @textLimit })
    @textarea = @$el.find("##{@textareaId}")
    _.defer(@_bindEditors)
    @

  depose: ->
  _bindEditors: =>
    Size = Quill.import('attributors/style/size');
    Size.whitelist = ['8px', '9px', '10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '36px', '48px', '72px'];
    Quill.register(Size, true);

    Font = Quill.import('formats/font');
    Font.whitelist = ['arial', 'comic-sans-ms', 'courier-new', 'georgia', 'lucida-sans-unicode', 'tahoma', 'times-new-roman', 'trebuchet-ms', 'verdana'];
    Quill.register(Font, true);

    Image = Quill.import('formats/image')
    Quill.register(Image, true);

    Block = Quill.import('blots/block');
    Block.tagName = 'DIV';
    Quill.register(Block, true);

    ImageDrop = Quill.import('modules/imageDrop');
    Quill.register(ImageDrop, true)

    toolbarOptions = [
      ['bold', 'italic', 'underline', 'clean', 'link', 'image','emoji'],
      ['undo', 'redo'],
      [
        { 'color': [] }, { 'background': [] },
        { 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' },
        { 'font': ['arial', 'comic-sans-ms', 'courier-new', 'georgia', 'lucida-sans-unicode', 'tahoma', 'times-new-roman', 'trebuchet-ms', 'verdana'] },
        { 'header': [1, 2, 3, 4, 5, 6, false] },
        { 'size': ['8px', '9px', '10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '36px', '48px', '72px'] }
      ]
    ];

    editorOptions =
      modules:
        imageDrop: true
        imageResize:
          displaySize: true
        history:
          delay: 2000
          userOnly: true
        toolbar:
          container: toolbarOptions
          handlers:
            undo: (value) ->
              @quill.history.undo()
              return
            redo: (value) ->
              @quill.history.redo()
              return
        'emoji-toolbar': true
        'emoji-shortname': true
      theme: 'snow'

    if @codeEditorEnabled == true
      Quill.register('modules/htmlEditButton', htmlEditButton)
      editorOptions.modules.htmlEditButton =
        buttonHTML: "&lt;html&gt;"


    try
      @editor = new Quill(
        '#editor_container' + @textareaId, editorOptions
      )
      @editor.on('editor-change', @_onTextChange)
    catch err
      if err == "blurred_container"
        return
      else
        errorHandler = new Monitoring.Methods.ErrorHandler(err)
        errorHandler.handle()

    executor = new SafelyExecutor =>
      if @text != ''
        @editor.setContents([])
        @insertHTMLAtIndex(0, @text)
      @editor.getModule("toolbar").addHandler("image", @imageHandler.bind(@));
      @trigger('editor:render:finish')

    $scrollParent = @_scrollParent()
    scrollTop = $scrollParent.scrollTop()
    executor.execute()
    $scrollParent.scrollTop(scrollTop)

  _scrollParent: ($baseElement = @$el) =>
    $scrollParent = $baseElement.scrollParent()
    return $scrollParent if $scrollParent.is(document)
    scrollParent = $scrollParent.get(0)
    return $scrollParent if scrollParent.scrollHeight > scrollParent.clientHeight
    @_scrollParent($scrollParent)

  imageHandler: =>
    @emptyImageModal()
    @insert_at = @editor.getSelection().index || 0
    @$el.find('#img-modal').modal();

  insertImage: ->
    _content = [{
      insert: {
        image: @$el.find('.url_image').val()
        insert_at: @insert_at
      },
      attributes: {
        alt: @$el.find('.texto_image').val()
        width: parseInt(@$el.find('.img_width').val())
        height: parseInt(@$el.find('.img_height').val())
        'border': @$el.find('.img_border').val() + "px solid #000000" if @$el.find('.img_border').val() != ''
        'margin-left': @$el.find('.img_esp_h').val() if @$el.find('.img_esp_h').val() != ''
        'margin-right': @$el.find('.img_esp_h').val() if @$el.find('.img_esp_h').val() != ''
        'margin-top': @$el.find('.img_esp_v').val() if @$el.find('.img_esp_v').val() != ''
        'margin-bottom': @$el.find('.img_esp_v').val() if @$el.find('.img_esp_v').val() != ''
      }
    }];
    @editor.updateContents(_content, Quill.sources.USER)

  loadImage: (e) ->
    @size_locked = true
    @$el.find(".img_lock").src = window.image_path('mini-lock.png')
    img_preview = document.getElementById('img_preview')
    img_preview.src = e.target.value;

  changeImgSettings: (e) =>
    _height = @$el.find(".img_height").val()
    _width = @$el.find(".img_width").val()

    if (!isNaN(_height) && !isNaN(_width))
      if @size_locked
        _new_dimensions = @calculate_dimensions($(e.target).data().changed, _width, _height)
        @setDimensionValues(_new_dimensions.width, _new_dimensions.height)
      else
        @setDimensionValues(_width, _height)

    @$el.find(".img_preview").css({"margin-bottom": @$el.find(".img_esp_v").val() + 'px'})
    @$el.find(".img_preview").css({"margin-top": @$el.find(".img_esp_v").val() + 'px'})
    @$el.find(".img_preview").css({"margin-left": @$el.find(".img_esp_h").val() + 'px'})
    @$el.find(".img_preview").css({"margin-right": @$el.find(".img_esp_h").val() + 'px'})

    @$el.find(".img_preview").css({"border": @$el.find(".img_border").val() + 'px solid #000000'})

  calculate_dimensions: (_changed, _width, _height) ->
    if _changed == "width"
      _new_height = @original_size.height * (_width / @original_size.width)
      return {'width': _width, 'height': _new_height}
    else
      _new_width = @original_size.width * (_height / @original_size.height)
      return {'width': _new_width, 'height': _height}

  setDimensionValues: (_width, _height) ->
    @$el.find(".img_preview").css({"width": _width + 'px'})
    @$el.find(".img_preview").css({"height": _height + 'px'})
    @$el.find(".img_height").val(parseInt(_height))
    @$el.find(".img_width").val(parseInt(_width))

  toggleImgLock: =>
    if @$el.find(".img_lock").data().locked == 'locked'
      @$el.find(".img_lock").attr("src", window.image_path('mini-unlock.png'))
      @$el.find(".img_lock").data().locked = 'unlocked'
      @size_locked = false
    else
      @$el.find(".img_lock").attr("src", window.image_path('mini-lock.png'))
      @$el.find(".img_lock").data().locked = 'locked'
      @size_locked = true


  update: =>
    @text = @getPlainHTML()
    @textarea.val(@text)
    true

  setHTML: (plainHTML) ->
    @text = plainHTML
    if @editor
      @editor.setContents([])
      @insertHTMLAtIndex(0, @text)
    @text

  focus: =>
    @textarea.focus()

  insertTextAtCursor: (text) ->
    selection = @editor.getSelection(true);
    @editor.insertText(selection.index, text);
    @text = @textarea.val()

  insertHTMLTextAtCursor: (text) ->
    selection = @editor.getSelection(true);
    @insertHTMLAtIndex(selection.index, text)

  textareaElement: ->
    @textarea

  getPlainHTML: ->
    @editor.container.firstChild.innerHTML

  getPlainText: ->
    @getPlainHTML().replace(/<(?:.|\n)*?>/gm, '');

  closeModal: ->
    @$el.find('#img-modal').modal('hide')

  insertHTMLAtIndex: (index, text) ->
    @editor.clipboard.dangerouslyPasteHTML(index, text)
    @trigger('editor:htmltext:inserted')

  emptyImageModal: ->
    @$el.find('.url_image').val('')
    @$el.find('.texto_image').val('')
    @$el.find('.img_width').val('')
    @$el.find('.img_height').val('')
    @$el.find('.img_border').val('')
    @$el.find('.img_esp_h').val('')
    @$el.find('.img_esp_v').val('')
    @$el.find('.img_container').html('<img class="img_preview" id="img_preview" style="width:auto;height:auto;max-width:330px;max-height:185px;vertical-align:middle;border:0;">')
    img_preview = document.getElementById('img_preview')
    img_preview.onload = () =>
      img = new Image();
      img.src = img_preview.src
      $(".img_width").val(img.width)
      $(".img_height").val(img.height)
      @original_size =  {'width': img.width, 'height': img.height}

  _onTextChange: (delta, oldDelta, source) =>
    @trigger('editor:htmltext:textChanged')

window.HtmlEditorView = HtmlEditorView
